module.exports = __webpack_public_path__ + "static/img/pic_cpys.39e8847f.png";